export const SET_REFRESH_RATE = "SET_REFRESH_RATE"
export const SET_PRODUCTION_LINE = "SET_PRODUCTION_LINE"
export const SET_IS_USER_ADMIN = 'SET_IS_USER_ADMIN'
export const SET_USER_EMAIL = 'SET_USER_EMAIL'
export const SET_UNIT = 'SET_UNIT'
